export const SAFARI_PATCH_KEY = "safari";
